import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { UserRole } from 'src/app/enums/user-role';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
    private _roles$ = new BehaviorSubject<Set<UserRole>>(new Set());
    private _isfboSelected$ = new BehaviorSubject<boolean>(false);

    roles$ = this._roles$.asObservable();
    isfboSelected$ = this._isfboSelected$.asObservable();

    constructor(private storage: StorageService) {
        const roles = this.storage.get<UserRole[]>(localStorageAccessConstant.permitedRoles) ;
        this._roles$.next(new Set(roles));
        
        // Check both fboId and isFboSelected from localStorage
        const fboId = this.storage.get<number>(localStorageAccessConstant.fboId);
        const isFboSelected = this.storage.get<boolean>(localStorageAccessConstant.isFboSelected);
        
        // FBO is selected if either fboId > 0 OR isFboSelected is true
        const ctx = (fboId && fboId > 0) || isFboSelected === true;
        this._isfboSelected$.next(ctx);
    }

    get rolesSnapshot(): Set<UserRole> {
        return this._roles$.value;
    }
    get isfboSelectedSnapshot(): boolean {
        return this._isfboSelected$.value;
    }

    setRoles(roles: UserRole[]) {
        const set = new Set(roles ?? []);
        this._roles$.next(set);
        this.storage.set(
            localStorageAccessConstant.permitedRoles,
            roles
        );
    }

    clearRoles() {
        this._roles$.next(new Set());
        this.storage.remove(localStorageAccessConstant.permitedRoles);
    }
    setIsFboSelected(selected: boolean) {
        this._isfboSelected$.next(selected);
        this.storage.set(
            localStorageAccessConstant.isFboSelected,
            selected
        );
    }
    clearIsFboSelected() {
        this._isfboSelected$.next(false);
        this.storage.remove(localStorageAccessConstant.isFboSelected);
    }

    hasAnyRole(required: UserRole[]): Observable<boolean> {
        return this.roles$.pipe(
            map((r) => required.some((role) => r.has(role)))
        );
    }

    hasRoleAndFbo(required: UserRole[]): boolean {
        const r = this.rolesSnapshot;
        return required.some((role) => r.has(role)) && this.isfboSelectedSnapshot || required.indexOf(UserRole.All) > -1;
    }
}
